import { render } from "./serviceGroups.vue?vue&type=template&id=6a1903b5"
import script from "./serviceGroups.vue?vue&type=script&lang=js"
export * from "./serviceGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__